app.controller('BrowseProductOverviewSolutionController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    let initialized = false;
    $scope.solution_view_id = "cabinets";

    $scope.overview_solution_listeners = {
        prepareEditGeneralOptions: null,
        prepareEditCabinetOptions: null
    }
    $scope.showSolutionOverviewView = function (viewID) {

        viewID = viewID ? viewID : "cabinets";
        if ($scope.solution_view_id === viewID && viewID === "cabinets") {
            return;
        }
        $scope.solution_view_id = $scope.solution_view_id !== viewID ? viewID : "cabinets";

        if ($scope.solution_view_id === "general_options") {
            if ($scope.overview_solution_listeners.prepareEditGeneralOptions) {
                $scope.overview_solution_listeners.prepareEditGeneralOptions();
            }
        }

        if ($scope.solution_view_id === "cabinet_options") {
            if ($scope.overview_solution_listeners.prepareEditCabinetOptions) {
                $scope.overview_solution_listeners.prepareEditCabinetOptions();
            }
        }


        const collapse = $("#solution-overview-accordion .collapse[data-solution-view-id='" + $scope.solution_view_id + "']")[0];
        if (!collapse) {
            return
        }
        new bootstrap.Collapse(collapse, {
            toggle: true
        });
    }

    const unbindCurrentPageClicked = $scope.$on('current_page_clicked', function ($event, params) {
        $scope.showSolutionOverviewView(null);
    });
    $scope.$on('$destroy', unbindCurrentPageClicked);

    const unbindEditSolutionCartCalled = $scope.$on('edit_solution_cart_called', function ($event, params) {
        if (!initialized) {
            return
        }
        handleExternalCall();
    });
    $scope.$on('$destroy', unbindEditSolutionCartCalled);


    function handleExternalCall() {
        if (!$rootScope.service.menu.edit_solution_cart_called) {
            return
        }
        $rootScope.service.menu.edit_solution_cart_called = false;
        if ($scope.consolidateCarts) {
            $scope.consolidateCarts();
        }
        $scope.showSolutionOverviewView("general_options");
    }


    $scope.on_edit_solution_general_options_ready = function () {
        initialized = true;
        handleExternalCall();
    }

}]);